const dev = {
  API_ENDPOINT_URL: 'http://127.0.0.1:5000'
};

const prod = {
  API_ENDPOINT_URL: 'https://ai-reviews.skyraantech.com/backend'
};

const test = {
  API_ENDPOINT_URL: '/'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
